export default "__VITE_PUBLIC_ASSET__55a5339c__"